import { createSignal } from "solid-js"
import { SelectionMode } from "../../lib/core/engine/SelectionMode/SelectionMode.enum"
import createSharedCachedFactory from "../memo/createSharedCachedFactory"

/**
 * Manages the current selection mode for map interactions
 * 
 * @example
 * const [getSelectionMode, setSelectionMode] = useSelectionModeSignal()
 */
const useSelectionModeSignal = createSharedCachedFactory(() => {
  // console.log('useSelectionModeSignal created')

  // eslint-disable-next-line solid/reactivity
  const signal = createSignal<SelectionMode>(SelectionMode.SingleSelect)
  // if (DEV) {
  //   const [getter] = signal
  //   function fn() {
  //     const value = getter()
  //     if (value === SelectionMode.SingleSelect) {
  //       console.log('Single select mode enabled')
  //     } else if (value === SelectionMode.MultiSelect) {
  //       console.log('Multi select mode enabled')
  //     } else {
  //       console.log('Unknown select mode:', value)
  //     }
  //   }
  //   createComputed(fn)
  // }
  return signal
})

export default useSelectionModeSignal

